import { NgModule } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { RouterModule } from '@angular/router'
import { SharedModule } from '@shared/shared.module'
import { CheckBoxSelectionService, MultiSelectModule } from '@syncfusion/ej2-angular-dropdowns'
import { ClientGridComponent } from './client-grid.component'
import { ClientImageContainerComponent } from './client-select/client-image.container'
import { ClientSelectComponent } from './client-select/client-select.component'
import { SelectedClientContainerComponent } from './client-select/selected-client.container'
import { StructureCardComponent } from './structure-card/structure-card.component'
import { StructureCardContainerComponent } from './structure-card/structure-card.container'
import { TierBarContainerComponent } from './tier-bar-container/tier-bar.container'
import { TierBarComponent } from './tier-bar.component/tier-bar.component'
import { TierStructuresDialogComponent } from './tier-structures-dialog.component/tier-structures-dialog.component'
import { TierStructuresMenuComponent } from './tier-structures-menu.component/tier-structures-menu.component'
import { TierStructuresComponent } from './tier-structures.component/tier-structures.component'
import { TierService } from './tier.service'
import { CreditTierStructuresMenuComponent } from './credit/credit-tier-structures-menu/credit-tier-structures-menu.component'
import { CreditTierStructuresDialogComponent } from './credit/credit-tier-structures-dialog/credit-tier-structures-dialog.component'
import { CreditTierStructuresContainerComponent } from './credit/credit-tier-structures/credit-tier-structures.container'
import { CreditTierStructuresComponent } from './credit/credit-tier-structures/credit-tier-structures.component'
import { CreditTierBarMultiselectContainerComponent } from './credit/credit-tier-bar-multiselect/credit-tier-bar-multiselect.container'
import { CreditTierBarMultiselectComponent } from './credit/credit-tier-bar-multiselect/credit-tier-bar-multiselect.component'
import { CreditStructureCardContainerComponent } from './credit/credit-structure-card/credit-structure-card.container'
import { CreditStructureCardComponent } from './credit/credit-structure-card/credit-structure-card.component'

const CREDIT_COMPONENTS = [
  CreditTierStructuresDialogComponent,
  CreditTierStructuresContainerComponent,
  CreditTierStructuresComponent,
  CreditTierBarMultiselectContainerComponent,
  CreditTierBarMultiselectComponent,
  CreditStructureCardContainerComponent,
  CreditStructureCardComponent,
]

const CREDIT_EXPORTS = [CreditTierStructuresMenuComponent]

const COMPONENTS = [
  ClientGridComponent,
  StructureCardComponent,
  TierStructuresDialogComponent,
  ...CREDIT_COMPONENTS,
]

const EXPORTS = [
  ClientImageContainerComponent,
  SelectedClientContainerComponent,
  StructureCardContainerComponent,
  TierBarComponent,
  TierBarContainerComponent,
  TierStructuresComponent,
  TierStructuresMenuComponent,
  ClientSelectComponent,
  ...CREDIT_EXPORTS,
]

@NgModule({
  declarations: [...COMPONENTS, ...EXPORTS],
  imports: [SharedModule, FormsModule, RouterModule, MultiSelectModule],
  exports: EXPORTS,
  providers: [TierService, CheckBoxSelectionService],
})
export class TierModule {}
